<template>
  <div class="account-card status-card" v-if="track_order_data">
    <div class="account-header">
      <h4 class="food-preparing" v-if="order_system_status">
        {{ _T('Please wait we are checking your order.') }}
      </h4>
      <h4 class="food-preparing" v-else-if="active_status === 4">
        {{ _T('Thank you, please visit again.') }}
      </h4>
      <h4 class="food-preparing" v-else>
        {{
          _T(
            'Please wait we are preparing your delices food, we will serve you soon.'
          )
        }}
      </h4>
    </div>
    <div class="area_table">
      <div v-if="dineinArea(isFloorTableAvailable.floor_id)">
        {{ _T('Area') }}:
        <b class="text-capitalize">
          {{ dineinArea(isFloorTableAvailable.floor_id).name }}
        </b>
      </div>
      <div v-if="dineinTableDetails">
        {{ _T('Table number') }}:
        <b>
          <span :class="'shape ' + dineinTableDetails.table_shape">
            {{ dineinTableDetails.number }}
          </span>
        </b>
      </div>
    </div>
    <span
      class="text-capitalize notification-msg"
      v-if="dineinNotificationUpdate"
    >
      {{ _T(dineinNotificationUpdate) }}
      <span class="close-notification" @click="hideNotification()">X</span>
    </span>
    <div class="account-body status-process">
      <ul class="row" v-if="order_system_status">
        <li class="col-lg-6 active">
          <div class="steps">
            <span>
              <svg
                width="23"
                height="27"
                viewBox="0 0 23 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3573 15.2812V1.83537L15.6967 0.177583L13.9796 1.88306L12.4216 0.325027L11.0081 1.73854L9.39223 0.132812L7.65353 1.87152L5.95094 0.155938L4.13853 1.97704L2.36656 0.207997L0.585938 1.9756V22.1968L2.25094 23.8575L3.96796 22.1448L5.52599 23.6985L6.9395 22.285L8.5409 23.898L10.2796 22.155L11.1641 23.0395C11.0615 22.5799 11.0124 22.1087 11.0167 21.6375C11.0138 19.9537 11.6816 18.3378 12.871 17.1453C14.0605 15.9528 15.6735 15.2823 17.3573 15.2809L17.3573 15.2812ZM3.51711 6.58913H14.3829V7.88413H3.51711V6.58913ZM3.51711 9.74134H11.1021V11.0363L3.51711 11.0378V9.74279V9.74134ZM9.59621 14.1813L3.51711 14.1828V12.8878H11.1021V14.1828H9.5961L9.59621 14.1813Z"
                ></path>
                <path
                  d="M17.3603 16.3907C15.2443 16.3922 13.3365 17.6669 12.5273 19.6225C11.718 21.578 12.1646 23.8282 13.659 25.3256C15.1549 26.823 17.4053 27.2725 19.3607 26.466C21.3177 25.6595 22.5953 23.7531 22.5997 21.6371C22.604 20.2453 22.0533 18.9084 21.0691 17.9227C20.0848 16.9384 18.7494 16.3863 17.3561 16.3907L17.3603 16.3907ZM20.1801 20.3046L16.7576 23.7271C16.6521 23.8311 16.5119 23.889 16.3645 23.8904C16.2185 23.8904 16.0769 23.8326 15.9728 23.7271L15.8283 23.5826L14.5448 22.3035C14.3266 22.0867 14.3266 21.734 14.5434 21.5172C14.7587 21.299 15.1114 21.299 15.3296 21.5158L16.3659 22.5521L19.3967 19.5212H19.3953C19.4993 19.4157 19.6395 19.3565 19.787 19.3565C19.9344 19.3565 20.076 19.4157 20.1801 19.5212C20.394 19.738 20.394 20.0878 20.1801 20.3046L20.1801 20.3046Z"
                ></path>
              </svg>
            </span>
          </div>
          <div>
            <h6>{{ _T('Order Placed') }}</h6>
            <h4>
              {{
                convertDate(
                  orderStatusHistoryTime(
                    track_order_data,
                    'ORDER_HISTORY_TYPE_RECORD_NEW'
                  )
                )
              }}
            </h4>
          </div>
        </li>
        <li class="col-lg-6 active">
          <div class="steps">
            <span>
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M12.8696 0.847656L14.6272 3.17225L12.8574 5.5128C16.5537 5.69963 19.4931 8.75553 19.4931 12.4977C19.4931 13.6384 19.218 14.7134 18.7345 15.6654L19.878 18.3722L22.7715 18.0117C23.6541 16.3696 24.1554 14.4928 24.1554 12.4979C24.1563 6.18336 19.1363 1.0431 12.8695 0.847704L12.8696 0.847656Z"
                  ></path>
                  <path
                    d="M6.27307 15.6815C5.78392 14.7267 5.50603 13.6451 5.50603 12.4989C5.50603 8.76125 8.438 5.70911 12.1268 5.51467L13.8975 3.17318L12.14 0.847656C5.8684 1.03824 0.84375 6.18115 0.84375 12.4989C0.84375 14.4902 1.34415 16.365 2.22386 18.0052L3.35893 15.3191L6.27307 15.6815Z"
                  ></path>
                  <path
                    d="M18.3701 16.3016C17.1243 18.2224 14.9611 19.4945 12.5004 19.4945C10.0463 19.4945 7.88868 18.229 6.64009 16.3165L3.72398 15.9531L2.58984 18.6383C4.64592 21.9504 8.31486 24.1568 12.5002 24.1568C16.6817 24.1568 20.3489 21.9543 22.406 18.6467L19.5135 19.0072L18.3701 16.3016Z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect
                      x="0.482422"
                      y="0.484375"
                      width="24.0345"
                      height="24.0345"
                      fill="white"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
          </div>
          <div
            v-if="
              track_order_data.order_system_status === 'requires_acceptance'
            "
          >
            <h6>{{ _T(orderStatus(track_order_data.order_status)) }}</h6>
            <h4>
              {{
                convertDate(
                  orderStatusHistoryTime(
                    track_order_data,
                    'ORDER_HISTORY_TYPE_RECORD_REQUIRES_ACCEPTANCE'
                  )
                )
              }}
            </h4>
          </div>
          <div v-else>
            <h6>{{ _T('Order Canceled') }}</h6>
            <h4>
              {{
                convertDate(
                  orderStatusHistoryTime(
                    track_order_data,
                    'ORDER_HISTORY_TYPE_RECORD_CANCELLED'
                  )
                )
              }}
            </h4>
          </div>
        </li>
      </ul>
      <ul class="row" v-else>
        <li class="col-lg-4 active">
          <div class="steps">
            <div class="steps-line"></div>
            <span>
              <svg
                width="23"
                height="27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 60 60"
                style="enable-background:new 0 0 60 60;"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M18.35,20.805c0.195,0.195,0.451,0.293,0.707,0.293c0.256,0,0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414
                    c-1.015-1.016-1.015-2.668,0-3.684c0.87-0.87,1.35-2.026,1.35-3.256s-0.479-2.386-1.35-3.256c-0.391-0.391-1.023-0.391-1.414,0
                    s-0.391,1.023,0,1.414c0.492,0.492,0.764,1.146,0.764,1.842s-0.271,1.35-0.764,1.842C16.555,16.088,16.555,19.01,18.35,20.805z"
                  />
                  <path
                    d="M40.35,20.805c0.195,0.195,0.451,0.293,0.707,0.293c0.256,0,0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414
                    c-1.015-1.016-1.015-2.668,0-3.684c0.87-0.87,1.35-2.026,1.35-3.256s-0.479-2.386-1.35-3.256c-0.391-0.391-1.023-0.391-1.414,0
                    s-0.391,1.023,0,1.414c0.492,0.492,0.764,1.146,0.764,1.842s-0.271,1.35-0.764,1.842C38.555,16.088,38.555,19.01,40.35,20.805z"
                  />
                  <path
                    d="M29.35,14.805c0.195,0.195,0.451,0.293,0.707,0.293c0.256,0,0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414
                    c-1.015-1.016-1.015-2.668,0-3.684c0.87-0.87,1.35-2.026,1.35-3.256s-0.479-2.386-1.35-3.256c-0.391-0.391-1.023-0.391-1.414,0
                    s-0.391,1.023,0,1.414c0.492,0.492,0.764,1.146,0.764,1.842s-0.271,1.35-0.764,1.842C27.555,10.088,27.555,13.01,29.35,14.805z"
                  />
                  <path
                    d="M55.624,43.721C53.812,33.08,45.517,24.625,34.957,22.577c0.017-0.16,0.043-0.321,0.043-0.48c0-2.757-2.243-5-5-5
                    s-5,2.243-5,5c0,0.159,0.025,0.32,0.043,0.48C14.483,24.625,6.188,33.08,4.376,43.721C2.286,44.904,0,46.645,0,48.598
                    c0,5.085,15.512,8.5,30,8.5s30-3.415,30-8.5C60,46.645,57.714,44.904,55.624,43.721z M27.006,22.27
                    C27.002,22.212,27,22.154,27,22.098c0-1.654,1.346-3,3-3s3,1.346,3,3c0,0.057-0.002,0.114-0.006,0.172
                    c-0.047-0.005-0.094-0.007-0.14-0.012c-0.344-0.038-0.69-0.065-1.038-0.089c-0.128-0.009-0.255-0.022-0.383-0.029
                    c-0.474-0.026-0.951-0.041-1.432-0.041s-0.958,0.015-1.432,0.041c-0.128,0.007-0.255,0.02-0.383,0.029
                    c-0.348,0.024-0.694,0.052-1.038,0.089C27.1,22.263,27.053,22.264,27.006,22.27z M25.126,26.635
                    c1.582-0.356,3.217-0.537,4.86-0.537c0.004,0,0.009,0,0.014,0c0.552,0,1,0.448,1,1.001c0,0.552-0.448,0.999-1,0.999h0
                    c-0.004,0-0.009,0-0.013,0c-1.496,0-2.982,0.164-4.421,0.488c-0.074,0.017-0.148,0.024-0.221,0.024c-0.457,0-0.87-0.315-0.975-0.78
                    C24.249,27.291,24.587,26.756,25.126,26.635z M19.15,28.997c0.476-0.281,1.088-0.124,1.37,0.351
                    c0.282,0.476,0.125,1.089-0.351,1.37c-4.713,2.792-8.147,7.861-9.186,13.56c-0.088,0.482-0.509,0.82-0.983,0.82
                    c-0.06,0-0.12-0.005-0.18-0.017c-0.543-0.099-0.904-0.619-0.805-1.163C10.158,37.658,13.947,32.08,19.15,28.997z M30,55.098
                    c-17.096,0-28-4.269-28-6.5c0-0.383,0.474-1.227,2.064-2.328c-0.004,0.057-0.002,0.113-0.006,0.17C4.024,46.988,4,47.54,4,48.098
                    v0.788l0.767,0.185c8.254,1.981,16.744,2.985,25.233,2.985s16.979-1.004,25.233-2.985L56,48.886v-0.788
                    c0-0.558-0.024-1.109-0.058-1.658c-0.004-0.057-0.002-0.113-0.006-0.17C57.526,47.371,58,48.215,58,48.598
                    C58,50.829,47.096,55.098,30,55.098z"
                  />
                </g>
              </svg>
            </span>
          </div>
          <div>
            <h6>{{ _T(CONST.IN_PROGRESS) }}</h6>
            <h4 v-if="track_order_data">
              {{
                convertDate(
                  orderStatusHistoryTime(
                    track_order_data,
                    'ORDER_HISTORY_TYPE_RECORD_SENT_TO_KITCHEN'
                  )
                )
              }}
            </h4>
          </div>
        </li>
        <li class="col-lg-4" :class="{ active: active_status > 1 }">
          <!-- <div class="steps-line"></div> -->
          <div class="steps">
            <span>
              <svg
                width="25"
                height="25"
                viewBox="0 0 300.167 300.167"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="enable-background:new 0 0 300.167 300.167;"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M251.39,157.505c-1.362-1.559-2.517-3.26-3.469-5.056c-0.468,48.27-39.875,87.398-88.254,87.398
                    c-48.669,0-88.265-39.596-88.265-88.265s39.596-88.265,88.265-88.265c41.868,0,77.02,29.304,86.027,68.477l7.993-59.42l0.18-1.336
                    c-22.76-26.581-56.544-43.457-94.2-43.457c-29.378,0-56.398,10.276-77.667,27.414v1.283v1.136v25.168v0.999
                    c0,16.811-8.713,32.159-22.5,40.929v98.378v1.695c22.574,30.89,59.063,50.998,100.167,50.998c43.192,0,81.291-22.203,103.5-55.79
                    v-1.817V165.28C258.661,163.814,254.578,161.151,251.39,157.505z"
                  />
                  <path
                    d="M159.667,78.318c-40.398,0-73.265,32.866-73.265,73.265s32.866,73.265,73.265,73.265s73.265-32.866,73.265-73.265
                    S200.065,78.318,159.667,78.318z"
                  />
                  <path
                    d="M299.833,14.476c0-6.384-5.175-11.559-11.559-11.559c-5.788,0-10.684,4.281-11.455,10.018l-16.89,125.549
                    c-0.445,3.305,0.56,6.64,2.754,9.15c2.195,2.51,5.366,3.949,8.701,3.949h6.782V286.25c0,6.075,4.925,11,11,11s11-4.925,11-11
                    L299.833,14.476z"
                  />
                  <path
                    d="M67,16.917c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v41.499H41V16.917c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5
                    v41.499H15V16.917c0-4.143-3.357-7.5-7.5-7.5S0,12.774,0,16.917v67.666c0,14.619,9.417,27.073,22.5,31.636V286.25
                    c0,6.075,4.925,11,11,11s11-4.925,11-11V116.219C57.583,111.656,67,99.202,67,84.583V16.917z"
                  />
                </g>
              </svg>
            </span>
          </div>
          <div>
            <h6>{{ _T('Order Served') }}</h6>
            <h4 v-if="active_status > 1">
              {{
                convertDate(orderStatusKitchenTime(track_order_data)) ||
                  convertDate(
                    orderStatusHistoryTime(
                      track_order_data,
                      'ORDER_HISTORY_TYPE_RECORD_COLLECTED_BY_USER'
                    )
                  )
              }}
            </h4>
          </div>
        </li>

        <li class="col-lg-4" :class="{ active: active_status > 3 }">
          <!-- <div class="steps-line"></div> -->
          <div class="steps">
            <span>
              <svg
                width="22"
                height="26"
                viewBox="0 0 75.376 75.376"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="enable-background:new 0 0 75.376 75.376;"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M56.206,47.937c-0.069-0.408-0.524-0.697-0.929-0.455c-0.819,0.488-1.726,0.609-2.531,1.232
                    c-0.977,0.754-1.364,2.299-1.304,3.465c0.12,2.316,2.21,3.65,4.347,3.748c2.482,0.113,4.63-1.885,4.614-4.361
                    C60.388,49.298,58.227,48.204,56.206,47.937z M57.919,51.855c-0.287,1.189-1.758,1.455-2.736,1.174
                    c-0.989-0.283-0.881-1.154-0.663-1.951c0.117-0.43,0.649-0.816,0.928-1.145c0.001-0.002,0.001-0.002,0.003-0.002
                    C56.575,50.042,58.244,50.505,57.919,51.855z"
                  />
                  <path
                    d="M68.884,39.841c0.212-4.092,0.554-8.678-2.784-11.441c-1.114-0.922-2.526-1.232-3.954-1.357
                    c0.928-1.293,1.649-2.836,2.619-4.057c1.16-1.459,3.639-4.16,2.042-6.311c-0.646-0.869-1.858-1.016-2.562-1.859
                    c-1.362-1.631-3.108-2.865-4.687-4.248c-3.776-3.313-7.571-6.332-11.986-8.608c-2.482-1.279-5.606-3.082-8.167-1.031
                    c-3.254,2.607-5.295,6.592-7.631,10.059c-3.073,4.561-6.204,9.047-9.711,13.24c-0.817,0.981-1.923,2.178-2.956,3.479
                    c-1.15,0.074-2.309,0.117-3.482,0.082c-0.27-0.006-1.772,0.07-3.369,0.205c-2.271-0.701-4.893-0.891-6.726,0.027
                    c-4.837,2.422-3.072,11.467-3.112,15.523c-0.061,6.217-0.501,12.547,0.142,18.75c-0.054,0.109-0.112,0.217-0.162,0.328
                    c-0.229,0.523-0.013,0.988,0.356,1.192c0.063,0.465,0.113,0.93,0.19,1.392c0.121,0.73,0.221,1.461,0.324,2.18
                    c-0.358,0.654-0.636,1.344-0.73,2.129c-0.086,0.711,0.732,1.16,1.332,1.016c0.29,1.045,0.699,1.973,1.338,2.705
                    c-0.138,0.725,0.686,1.248,1.315,1.031c0.732,0.381,1.643,0.619,2.795,0.664c2.365,0.096,4.746-0.658,7.131-0.662
                    c4.178-0.008,8.355-0.016,12.532-0.021c0.856-0.002,1.716-0.014,2.58-0.031c0.254,0.117,0.557,0.123,0.836-0.02
                    c4.895-0.113,9.885-0.379,14.771-0.176c0.324,0.303,0.895,0.348,1.265,0.074c1.175,0.068,2.343,0.158,3.501,0.297
                    c4.832,0.584,13.352,2.34,17.698-0.998c3.668-2.816,2.514-9.275,1.479-13.154c-0.039-0.15-0.117-0.264-0.208-0.363
                    c1.08-1.467,1.831-3.33,2.123-5.672C73.313,51.917,74.079,37.241,68.884,39.841z M48.18,7.565c0.287-0.307,0.582-0.598,0.882-0.877
                    c0.111,0.068,0.223,0.137,0.333,0.205c-0.461,0.281-0.916,0.607-1.363,0.973C48.086,7.767,48.128,7.667,48.18,7.565z
                    M52.375,12.972c0.74-0.881,1.512-1.701,2.033-2.666c2.917,2.242,5.628,4.775,7.77,7.342c0.435,0.521,1.139,0.826,1.686,1.149
                    c-0.255-0.15-1.619,1.82-1.782,2.016c-1.266,1.508-2.149,4.084-3.658,5.258c-0.296,0.23-0.465,0.529-0.539,0.848
                    c-0.494,0.002-0.992,0.014-1.486,0.02c0.11-0.117,0.226-0.232,0.334-0.352c0.481-0.531,0.793-1.279,0.488-1.963
                    c-0.123-0.273-0.539-0.232-0.674,0c-0.321,0.561-0.72,0.891-1.233,1.281c-0.391,0.295-0.781,0.643-1.016,1.068
                    c-0.719,0.017-1.437,0.035-2.153,0.051c0.002-0.017,0.01-0.035,0.01-0.053c0.479-0.525,0.941-1.072,1.405-1.607
                    c0.503-0.58,1.338-1.041,1.121-1.936l-0.018,0.016c-0.089-0.266-0.461-0.463-0.695-0.109c-0.133,0.205-0.688,0.367-0.899,0.504
                    c-0.347,0.225-0.655,0.488-0.966,0.758c-0.643,0.557-1.317,1.09-1.902,1.707c-0.23,0.242-0.29,0.51-0.257,0.756
                    c-0.266,0.004-0.531,0.008-0.796,0.01c-0.462,0-0.924-0.004-1.386-0.006c0.457-0.799,0.907-1.602,1.67-2.186
                    c0.56-0.428,0.056-1.383-0.569-0.975c-0.7,0.459-1.259,1.043-1.771,1.701c-0.354,0.453-0.735,0.943-1.062,1.455
                    c-1.511-0.012-3.02-0.023-4.531-0.039c1.829-2.109,3.417-4.502,5.021-6.68C48.388,17.808,50.355,15.378,52.375,12.972z
                    M30.739,18.349c1.754-2.727,3.751-5.291,5.541-7.994c2.118-3.197,4.151-7.832,8.546-5.883c0.785,0.348,1.581,0.742,2.382,1.166
                    c-2.475,1.859-4.624,5.322-6.109,7.322c-0.02,0.027-0.04,0.055-0.062,0.08c-3.877,4.564-7.703,9.178-11.309,13.99
                    c-0.329,0.006-0.658,0.021-0.986,0.031c0.387-0.547,0.933-1.006,1.351-1.529c0.261-0.324-0.096-0.934-0.488-0.631
                    c-0.532,0.408-1.108,0.74-1.587,1.215c-0.199,0.197-0.545,0.59-0.741,0.99c-0.271,0.012-0.544,0.016-0.814,0.027
                    c-0.161,0.006-0.318,0.019-0.477,0.027c0.854-0.916,1.565-1.959,2.522-2.783c0.526-0.453-0.145-1.24-0.716-0.928
                    c-1.34,0.729-2.252,1.859-3.272,2.955c-0.226,0.244-0.266,0.586-0.16,0.863c-0.447,0.037-0.894,0.072-1.338,0.113
                    C25.678,24.374,28.688,21.54,30.739,18.349z M66.763,70.946c-0.269,0.08-0.542,0.135-0.814,0.201
                    c0.057-0.25,0.076-0.506,0.042-0.773c-0.069-0.527-0.857-0.742-1.003-0.135c-0.111,0.467-0.477,0.895-0.865,1.264
                    c-1.211,0.172-2.434,0.248-3.665,0.242c0.499-0.664,0.86-1.402,0.832-2.23c-0.019-0.578-0.967-0.764-1.056-0.143
                    c-0.138,0.965-1.033,1.668-1.85,2.309c-0.872-0.055-1.744-0.129-2.613-0.221c0.313-0.275,0.524-0.736,0.82-1.029
                    c0.42-0.414,0.88-0.781,1.293-1.205c0.729-0.75-0.37-1.828-1.141-1.141c-0.442,0.396-0.917,0.748-1.38,1.119
                    c-0.299,0.238-0.572,0.771-0.883,0.941c-0.411,0.225-0.852,0.6-1.241,1.029c-0.437-0.053-0.872-0.104-1.304-0.154
                    c-0.57-0.066-1.145-0.111-1.717-0.166c0.024-0.209,0.031-0.426-0.007-0.654c-0.109-0.676-1.098-0.58-1.269,0
                    c-0.053,0.178-0.157,0.35-0.275,0.52c-0.868-0.064-1.741-0.119-2.616-0.162c0.143-0.229,0.298-0.449,0.468-0.662
                    c0.434-0.545-0.217-1.195-0.761-0.762c-0.393,0.316-0.76,0.645-1.093,1.023c-0.084,0.1-0.166,0.201-0.244,0.305
                    c-0.013,0.016-0.018,0.021-0.028,0.033c-1.189-0.037-2.38-0.064-3.576-0.072c0.242-0.334,0.482-0.668,0.71-1.019
                    c0.341-0.527-0.335-1.205-0.863-0.863c-0.774,0.502-1.63,1.113-2.211,1.885c-1.148,0.01-2.297,0.023-3.446,0.047
                    c0.009-0.01,0.013-0.023,0.024-0.033c0.604-0.664-0.381-1.654-0.988-0.988c-0.215,0.236-0.361,0.49-0.527,0.758
                    c-0.055,0.086-0.108,0.189-0.163,0.299c-1.375,0.031-2.748,0.072-4.119,0.109c0.062-0.158,0.123-0.313,0.186-0.455
                    c0.308-0.701,0.815-1.484,1.262-2.107c0.355-0.498-0.391-0.979-0.803-0.619c-0.62,0.543-1.281,1.293-1.684,2.01
                    c-0.217,0.385-0.488,0.793-0.708,1.215c-1.339,0.037-2.678,0.072-4.006,0.094c0.202-0.34,0.371-0.693,0.453-1.08
                    c0.12-0.563-0.552-1.012-0.987-0.576c-0.592,0.594-1.245,1.088-1.778,1.682c-0.505,0.004-1.009,0.008-1.511,0.006
                    c-0.227,0-0.67,0.031-1.236,0.078c0.108-0.127,0.221-0.252,0.331-0.377c0.452-0.523,0.876-1.104,0.824-1.83
                    c-0.037-0.541-0.894-0.734-1.003-0.135c-0.118,0.66-0.919,0.994-1.403,1.369c-0.364,0.283-0.713,0.695-0.928,1.154
                    c-0.707,0.057-1.463,0.113-2.233,0.158c0.234-0.395,0.447-0.805,0.63-1.242c0.078-0.186,0.581-0.504,0.765-0.684
                    c0.262-0.256,0.417-0.689,0.372-1.051c-0.064-0.523-0.772-0.846-1.076-0.291c-0.107,0.195-0.543,0.381-0.729,0.5
                    c-0.273,0.174-0.625,0.367-0.796,0.652c-0.468,0.781-0.908,1.541-1.531,2.207c-1.066,0.014-2.045-0.02-2.792-0.139
                    c0.331-0.533,0.67-1.063,1.059-1.555c0.678-0.859,1.527-1.936,1.407-3.094c-0.05-0.48-0.64-0.551-0.818-0.111
                    c-0.21,0.518-0.869,0.949-1.252,1.346c-0.512,0.531-1.005,1.1-1.469,1.676c-0.167,0.207-0.33,0.42-0.493,0.631
                    c-0.419-1.211-0.724-2.516-0.942-3.865c0.269-0.426,0.524-0.84,0.727-1.229c0.548-1.047,1.048-2.137,1.776-3.08
                    c0.429-0.555,0.783-0.953,0.93-1.648c0.168-0.791-0.909-1.064-1.191-0.33c-0.322,0.838-1.337,1.332-1.85,2.057
                    c-0.267,0.379-0.515,0.771-0.758,1.17c-0.068-0.838-0.114-1.676-0.146-2.506c0.201-0.344,0.39-0.688,0.559-1.037
                    c0.365-0.756,0.803-1.465,1.14-2.236c0.25-0.574,0.408-1.26,0.744-1.787c0.268-0.418-0.386-0.938-0.696-0.537
                    c-0.662,0.855-1.212,1.84-1.817,2.77c-0.006-0.57-0.008-1.131-0.011-1.672c-0.002-0.424-0.004-0.848-0.005-1.272
                    c0.211-0.32,0.437-0.633,0.697-0.935c0.874-1.018,1.332-2.35,2.211-3.4c0.384-0.461-0.214-1.084-0.665-0.666
                    c-0.871,0.809-1.542,1.754-2.254,2.678c-0.006-1.25-0.022-2.498-0.033-3.748c0.4-0.646,0.771-1.31,1.179-1.873
                    c0.235-0.322-0.244-0.592-0.506-0.391c-0.243,0.188-0.47,0.389-0.688,0.594C5.68,46.7,5.68,46.3,5.674,45.897
                    c1.249-1.146,1.926-2.652,3.063-3.9c0.514-0.563-0.273-1.35-0.836-0.836c-0.875,0.803-1.46,1.682-2.22,2.568
                    c-0.016,0.02-0.034,0.033-0.05,0.051c-0.021-1.092-0.035-2.184-0.067-3.275c-0.005-0.182-0.017-0.367-0.025-0.551
                    c0.02-0.008,0.044-0.012,0.063-0.023c0.428-0.283,1.008-0.787,1.225-1.322c0.665-0.469,1.156-1.143,1.872-1.537
                    c0.85-0.467,0.093-1.76-0.759-1.299c-0.416,0.227-0.771,0.527-1.109,0.856c-0.164,0.158-0.324,0.32-0.491,0.475
                    c-0.214,0.199-0.505,0.299-0.708,0.5c-0.129,0.129-0.128,0.299-0.218,0.418c-0.138-1.918-0.239-3.865,0.298-5.689
                    c0.259-0.879,0.85-1.51,1.61-1.939c0.046,0.01,0.089,0.025,0.137,0.029c9.755,1.072,19.82-0.123,29.679-0.168
                    c0.285,0.104,0.604,0.117,0.9,0c0.487,0.002,0.975,0.002,1.462,0.01c5.858,0.098,11.737,0.131,17.596,0.033
                    c2.885-0.049,7.247-0.826,8.329,2.766c0.681,2.258,0.21,5.305,0.165,7.777c-4.262-0.5-8.772-0.484-13.005-0.244
                    c-3.131,0.176-5.113,1.725-6.271,4.512c-1.884,4.541-0.898,8.555-0.109,13.213c0.684,4.033,4.685,4.564,7.892,5.307
                    c5.375,1.244,11.098,1.07,14.854-1.775c-0.287,1.674-0.347,3.33-0.354,5.086C68.591,68.86,68.969,70.286,66.763,70.946z
                    M69.905,53.11c-0.021,3.066-1.138,5.037-2.854,6.26c0.324-0.553,0.647-1.107,0.983-1.652c0.239-0.387-0.248-0.912-0.644-0.643
                    c-0.867,0.594-1.492,1.469-2.104,2.313c-0.287,0.398-0.563,0.801-0.852,1.199c-0.567,0.162-1.159,0.285-1.772,0.369
                    c0.149-0.125,0.293-0.258,0.432-0.391c0.511-0.482,1.033-1.014,1.365-1.637c0.165-0.307-0.188-0.565-0.43-0.42
                    c0-0.002,0.001-0.006,0.001-0.008c-0.465,0.248-0.86,0.588-1.293,0.889c-0.415,0.289-1.066,0.783-1.557,0.842
                    c-0.487,0.059-0.701,0.508-0.641,0.879c-0.735,0.01-1.481-0.016-2.222-0.074c0.337-0.385,0.645-0.793,0.951-1.168
                    c0.273-0.338-0.138-0.748-0.476-0.475c-0.432,0.352-0.862,0.697-1.314,1.023c-0.228,0.164-0.465,0.311-0.699,0.457
                    c-0.142-0.018-0.275-0.043-0.415-0.064c0.448-0.453,0.852-0.924,1.214-1.453c0.176-0.256-0.168-0.588-0.421-0.422
                    c-0.772,0.5-1.715,0.98-2.503,1.59c-0.417-0.078-0.833-0.158-1.227-0.246c-0.075-0.018-0.151-0.031-0.227-0.047
                    c0.299-0.336,0.623-0.65,0.984-0.928c0.516-0.393,0.246-1.359-0.476-1.129c-0.874,0.281-1.707,0.887-2.25,1.666
                    c-0.719-0.23-1.371-0.609-1.847-1.416c0.036,0.061-0.952-4.26-1.18-4.998c-0.727-2.361-0.272-7.611,2.111-9.316
                    c2.056-1.471,6.527-0.646,8.915-0.691c2.406-0.045,4.777-0.063,7.158-0.377c0.576,0.199,1.261,0.086,1.711-0.334
                    C71.846,44.378,69.927,49.812,69.905,53.11z"
                  />
                </g>
              </svg>
            </span>
          </div>
          <div>
            <h6>{{ _T('Payment') }}</h6>
            <h4 v-if="active_status > 3">
              {{
                convertDate(
                  orderStatusHistoryTime(
                    track_order_data,
                    'ORDER_HISTORY_TYPE_RECORD_COLLECTED_BY_USER'
                  )
                )
              }}
            </h4>
          </div>
        </li>
      </ul>
    </div>
    <div class="text-center dinein-actions">
      <button
        class="btn btn-solid"
        v-if="!order_system_status && active_status < 4"
        @click="addToOrder"
      >
        {{ _T('Add to Order') }}
      </button>
      <button v-if="disable_btn_1" class="btn btn-solid disabled">
        {{ _T('Call Waiter') }} {{ disable_btn_1 }}
      </button>
      <button
        v-else
        class="btn btn-solid"
        @click="notifyToStore({ message: 'Calling waiter' })"
      >
        {{ _T('Call Waiter') }}
      </button>
      <!-- <button class="btn btn-solid disabled" v-if="disable_btn_2" @click="showItemsStatus">
        {{ _T('Items status') }}  {{ disable_btn_2 }}
      </button> -->
      <button
        class="btn btn-solid"
        @click="showItemsStatus"
        v-if="active_status < 4"
      >
        {{ _T('Items status') }}
      </button>
      <!-- <button v-if="disable_btn_2" class="btn btn-solid disabled">
        {{ _T('Ask for Bill') }} {{ disable_btn_2 }}
      </button> -->
      <button
        class="btn btn-solid"
        v-if="!order_system_status && active_status > 1"
        @click="notifyToStore({ message: 'Asking for bill' })"
      >
        {{ _T('Ask for Bill') }}
      </button>
    </div>
    <span>
      <svg
        height="80px"
        width
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 52.539 52.539"
        style="enable-background:new 0 0 52.539 52.539;"
        xml:space="preserve"
      >
        <g>
          <path
            style="fill:#808080;"
            d="M39.377,21.163c-2.969-4.241-6.556-7.944-11.189-10.349c-0.236-0.122-2.469-0.94-3.418-1.057
            l-2.249,3.208l-2.1-2.997c-1.203,0.061-1.673-0.044-2.968,0.43c-2.182,0.799-3.818,6.348-4.585,8.535
            c-0.768,2.187,1.522,3.549,3.21,4.003h7.889c1.003,0,1.819-0.817,1.819-1.82c0-1.003-0.815-1.819-1.819-1.819h-6.015v-0.804h6.015
            c1.446,0,2.624,1.177,2.624,2.623s-1.178,2.623-2.624,2.623h-6.588l-0.271,25.82c0,1.646,1.334,2.98,2.981,2.98
            c1.646,0,2.981-1.334,2.981-2.98V36.012c0,0,0.029,0.132-0.016-1.033c0.85-2.034,1.938-0.221,1.938-0.221l1.065,11.5
            c0.121,1.388,1.369,2.687,2.758,2.563c1.39-0.122,2.392-1.616,2.271-3.005l-1.072-11.58l0.006-0.001c0,0-1.473-14.48-1.673-14.644
            c0.06-0.895,0.11-1.789,0.155-2.686c2.529,1.82,4.674,4.104,6.486,6.693C36.827,26.225,41.233,23.814,39.377,21.163z"
          />
          <circle style="fill:#808080;" cx="22.884" cy="4.349" r="4.349" />
          <path
            style="fill:#808080;"
            d="M22.57,10.133h-0.323c-0.025-0.211-0.229-0.376-0.478-0.376c-0.268,0-0.484,0.188-0.484,0.419
            v0.561c0,0.231,0.217,0.419,0.484,0.419c0.26,0,0.471-0.179,0.481-0.402h0.316c0.01,0.223,0.221,0.402,0.482,0.402
            c0.266,0,0.483-0.188,0.483-0.419v-0.561c0-0.231-0.217-0.419-0.483-0.419C22.798,9.757,22.595,9.922,22.57,10.133z"
          />
        </g>
      </svg>
    </span>
    <div class="account-footer">
      <h4 class="food-preparing-footer" v-if="active_status === 4">
        {{ _T('') }}
        <a @click="placeMoreOrder" href="javascript:void(0)">
          {{ _T(' click here ') }}
        </a>
        {{ _T('to place more order') }}
      </h4>
      <h4 class="food-preparing" v-else>
        {{ _T('We appreciate your patience.') }}
      </h4>
    </div>
    <items-status></items-status>
  </div>
</template>

<script>
import * as CONST from '@/constants'
import { mapGetters } from 'vuex'
import ItemsStatus from './ItemsStatus'
export default {
  name: 'QrTableOrderStatus',
  components: {
    ItemsStatus,
  },
  data() {
    return {
      disable_btn_1: 0,
      disable_btn_2: 0,
      interval: undefined,
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      'track_order_data',
      'orderStatus',
      'orderStatusHistoryTime',
      'orderStatusKitchenTime',
      'isFloorTableAvailable',
      'dineinArea',
      'currentBrandSlug',
      'currentStoreSlug',
      'dineinTable',
      'dineinNotificationUpdate',
      'order_type',
    ]),
    dineinTableDetails() {
      if (this.isFloorTableAvailable.table_id) {
        return this.dineinTable(this.isFloorTableAvailable.table_id)
      }
      return undefined
    },
    active_status() {
      let active_status = 1
      if (
        this.track_order_data.order_system_status ===
        CONST.ORDER_SYSTEM_STATUS_REJECTED
      ) {
        this.resetData()
        clearInterval(this.interval)
      }
      if (this.track_order_data.kitchen_history.finished.length > 0)
        active_status = 2
      if (this.track_order_data.order_status === 'on-a-way') active_status = 3
      if (this.track_order_data.order_status === 'finished') {
        active_status = 4
        this.reset()
        // this.$store.dispatch('getFloorTableInformation', {table_id:undefined, floor_id:undefined}, {
        //   root: true,
        // })
      }
      return active_status
    },
    order_system_status() {
      let system_status = false
      if (
        this.track_order_data.order_system_status ===
          CONST.ORDER_SYSTEM_STATUS_ACCEPTANCE ||
        this.track_order_data.order_system_status ===
          CONST.ORDER_SYSTEM_STATUS_REJECTED
      ) {
        system_status = true
      }
      return system_status
    },
  },
  methods: {
    resetData() {
      let details = { table_id: undefined, floor_id: undefined }
      localStorage.setItem('getFloorTableInformation', '')
      this.$store.commit('SET_DINEIN_FLOOR_TABLE', details)
      this.$store.commit('SET_ORDER_ID', undefined)
      this.$store.commit('SET_ORDER_TYPE', CONST.ORDER_TYPE_ONLINE)
    },
    reset() {
      if (this.isFloorTableAvailable.table_id) {
        let myInterval = setInterval(() => {
          this.resetData()
          clearInterval(myInterval)
          this.$router.push({ name: 'home' })
        }, 2000 * 60)
      }
    },
    placeMoreOrder() {
      this.$store.commit('SET_ORDER_ID', undefined)
      this.$router.push({
        name: 'dine_in_items_selection',
        params: {
          brand_id: this.currentBrandSlug || this.track_order_data.brand_id,
          store_id: this.currentStoreSlug || this.track_order_data.store_id,
          floor_id: this.isFloorTableAvailable.floor_id,
          table_id: this.isFloorTableAvailable.table_id,
        },
      })
    },
    showItemsStatus() {
      this.$bvModal.show('item-status')
    },
    addToOrder() {
      // this.$store.dispatch('load_brand_menu_items').then(() => {
      if (this.track_order_data) {
        this.$store.dispatch('reAddItemsToCart', this.track_order_data.items)
      }
      this.$router.push({
        name: 'dine_in_add_to_order',
        params: {
          brand_id: this.currentBrandSlug || this.track_order_data.brand_id,
          store_id: this.currentStoreSlug || this.track_order_data.store_id,
          order_id: this.track_order_data._id,
        },
      })
      // })
    },
    hideNotification() {
      this.$store.commit('DINE_IN_NOTIFY', undefined)
    },
    notifyToStore(data) {
      if (data.message == 'Calling waiter') {
        this.disable_btn_1 = 30
      } else {
        this.disable_btn_2 = 30
      }
      this.$store.dispatch('notifyStoreAboutTable', data)
      let myInterval = setInterval(() => {
        if (data.message == 'Calling waiter') {
          if (this.disable_btn_1 <= 1) {
            clearInterval(myInterval)
          }
          this.disable_btn_1 -= 1
        } else {
          if (this.disable_btn_2 <= 1) {
            clearInterval(myInterval)
          }
          this.disable_btn_2 -= 1
        }
      }, 1000)
    },
    // orderStatus(order_status) {
    //   if (order_status) {
    //     return order_status.replace(/-/g, ' ')
    //   }
    //   return order_status
    // },
    convertDate(datetime) {
      return datetime //? datetime.date.split('.')[0] : 0
    },
    trackOrder() {
      if (this.order_type === CONST.ORDER_TYPE_DINEIN) {
        this.$store.dispatch('orderTracking', this.$route.params.order_id, {
          root: true,
        })
      }
    },
  },
  // beforeMount() {
  //   let orderId = this.$route.params.order_id
  //   if (orderId) this.trackOrder()
  // },
  mounted() {
    let orderId = this.$route.params.order_id
    this.interval = setInterval(() => {
      if (orderId) this.trackOrder()
    }, 1000 * 30)
  },
}
</script>

<style lang="scss" scoped>
.notification-msg {
  display: flex;
  justify-content: center;
  padding: 10px;
  bottom: 0px;
  position: fixed;
  color: #fff;
  background: mediumseagreen;
  width: 100%;
  z-index: 1;
  .close-notification {
    position: absolute;
    font-size: 14px;
    line-height: 1.5;
    background-color: var(--color-primary);
    padding: 5px 11px;
    border-radius: 100%;
    color: #fff;
    right: 1px;
    top: -17px;
  }
}
.shape {
  background-color: rgb(57, 157, 77);
  border-radius: 80px;
  padding: 5px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.45);
  text-align: center;
  color: #fff;
}

.circle {
  height: 35px;
  max-width: 35px;
  padding: 5px 9px;
  border-radius: 50%;
}

.square {
  height: 35px;
  max-width: 35px;
  padding: 4px 10px;
  border-radius: 5%;
}

.rectangle {
  border-radius: 5%;
  height: 35px;
  max-width: 50px;
}
.food-preparing {
  display: flex;
  text-align: center;
  color: #808080;
}
.dinein-actions {
  margin-bottom: 25px;
  button {
    margin: $px5;
    width: 160px;
  }
}
.area_table {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  margin-top: 15px;
}
.status-card {
  @media (max-width: 575px) {
    // border-top: $px12 solid $light-border;
    border-radius: 0;
  }
  .account-header {
    padding-top: $px10;
    border-bottom: 1px solid $light-border;
    justify-content: center;
    display: flex;
  }
  .account-footer {
    padding-top: $px5;
    margin-top: $px5;
    border-top: 1px solid $light-border;
    justify-content: center;
    display: flex;
    .food-preparing-footer {
      text-align: center;
      color: grey;
    }
  }

  .status-process {
    padding: $px30 $px30;

    ul {
      li {
        text-align: center;
        .steps {
          padding: $px10 $px10 $px10 $px10;
          // width: $px220;
          // border: $px2 solid $light-border;
          border-radius: $px50;
          position: relative;
        }
        span {
          width: $px50;
          height: $px50;
          display: block;
          margin: 0 auto;
          text-align: center;
          border: $px2 solid $light-border;
          border-radius: 50%;
          padding: $px10;
          background-color: $white;
        }

        h4 {
          //text-align: center;
          line-height: $px28;
          color: $light-font;
          margin-bottom: 0;
          margin-top: 0;
          font-size: $px14;
          font-weight: 600;
        }

        h6 {
          margin-bottom: 0;
          font-weight: 600;
          color: $font-color;
        }

        &.active {
          .steps {
            border-color: $primary-color;

            svg {
              path {
                fill: $primary-color;
              }
            }

            span {
              border: $px2 solid $primary-color;
            }

            h4 {
              color: $font-color;
            }

            &::before {
              border-top: $px2 solid $primary-color;
            }
          }
          &::before {
            border-color: $primary-color;
          }
        }

        &:first-child {
          &::before {
            display: none;
          }
        }

        &::before {
          position: absolute;
          content: '';
          width: 100%;
          border-top: $px2 solid $light-border;
          top: 23%;
          left: -50%;
          z-index: -1;
        }

        svg {
          path {
            fill: $light-border;
          }
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .status-card {
    .status-process {
      ul {
        li {
          display: flex;
          align-items: center;
          text-align: left;
          h4 {
            margin-bottom: 0;
          }
          &::before {
            width: $px1;
            border-right: 0.125rem solid var(--color-light-border);
            border-left: none;
            top: -70%;
            left: 11.5%;
            height: 100%;
          }
          + li {
            margin-top: $px15;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .status-card {
    .status-process {
      ul {
        li {
          &::before {
            left: $px48;
          }
        }
      }
    }
  }
}
</style>
